import {createActions, createReducer} from 'reduxsauce'
import Immutable from 'seamless-immutable'
import {CommonTypes} from '../../Redux/CommonTypes';
import Moment from 'moment/min/moment-with-locales.min';
import {getLangCookie, setLanguageInCookieIfNeeded} from "../../Common/Cookie";

const {Types} = createActions({
    sendValidatePhoneRequest: [],
    sendValidatePhoneSuccess: ['hash'],
    sendValidatePhoneError: ['error'],
    // RESEND
    resendValidatePhoneRequest: [],
    resendValidatePhoneError: ['error'],

    clearValidationHash: [],
    validateCodeRequest: [],
    validateCodeSuccess: [],
    validateCodeError: ['error'],
    createCustomerRequest: [],
    createCustomerSuccess: ['updatedToken'],
    createCustomerError: ['error'],
    replaceToken: [],
    toggleIdentificationMode: ['mode']
});


export const IdentifyTypes = Types;


const initLang = () => {
    let isHebrew;
    let cookieLang = getLangCookie();
    let userDefinedLanguage = false;
    if (cookieLang) {
        isHebrew = cookieLang === 'he-IL';
        userDefinedLanguage = true;
    } else {
        isHebrew = (window.preferredLanguage && window.preferredLanguage === 'he') ||
            navigator.languages.filter(x => x.toLowerCase().includes('he'))[0] || !navigator.languages.filter(x => x.toLowerCase().includes('en'))[0];
    }

    Moment.locale(isHebrew ? 'he' : 'en');
    const lang = isHebrew ? 'he-IL' : 'en-US';
    if (isHebrew) {
        setLanguageInCookieIfNeeded(lang, true);
    }

    return {lang, userDefinedLanguage};
}

export const INITIAL_STATE = Immutable(Object.assign({
    // Regular config:
    sendingValidationCode: false,
    sendingValidationError: null,
    phoneHash: null,
    lastActivity: new Date(),
    identificationMode: 'phone',
}, initLang()));

const requestSendValidatePhone = (state) =>
    state.merge({sendingValidationCode: true, validationHashResponse: null, sendingValidationError: null});

const successSendValidatePhone = (state, {validationHash, resentCode}) => {
    return state.merge({
        sendingValidationCode: false,
        resendingCode: false,
        resentCode,
        validationHashResponse: validationHash,
        sendingValidationError: null
    });
};

const failureSendValidatePhone = (state, {error}) => state.merge({
    sendingValidationCode: false,
    sendingValidationError: error,
    validationHashResponse: null
});


const clearValidationHash = (state) =>
    state.merge({phoneHash: null});


const requestValidationCode = (state) =>
    state.merge({validatingCode: true, codeValidated: false, validatingCodeError: null});

const successValidationCode = (state) => {
    return state.merge({
        validatingCode: false, codeValidated: true, validatingCodeError: null
    });
};

const failureValidationCode = (state, {error}) => state.merge({
    validatingCode: false, codeValidated: false, validatingCodeError: error
});


const requestCreateCustomer = (state) =>
    state.merge({creatingCustomer: true, updatedToken: null, createCustomerError: null});

const successCreateCustomer = (state, {updatedToken}) => {
    return state.merge({
        creatingCustomer: false, updatedToken, createCustomerError: null
    });
};

const failureCreateCustomer = (state, {error}) => state.merge({
    creatingCustomer: false, updatedToken: null, createCustomerError: error
});

const replaceToken = () => INITIAL_STATE;

const updateActivity = (state, {currentTime}) => state.merge({lastActivity: currentTime});

const setLanguage = (state, {lang, force}) => {
    setLanguageInCookieIfNeeded(lang, force);
    if (!force && state.userDefinedLanguage) {
        return state;
    }

    return state.merge({lang});
};


const requestReSendValidatePhone = (state) => state.merge({resendingCode: true, resendingCodeError: null});
const failureReSendValidatePhone = (state, {error}) => state.merge({
    resendingCode: false,
    resendingCodeError: error
});

const toggleIdentificationMode = (state, {mode}) => {
    return state.merge({identificationMode: mode});
};

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.SEND_VALIDATE_PHONE_REQUEST]: requestSendValidatePhone,
    [Types.SEND_VALIDATE_PHONE_SUCCESS]: successSendValidatePhone,
    [Types.SEND_VALIDATE_PHONE_ERROR]: failureSendValidatePhone,
    [Types.CLEAR_VALIDATION_HASH]: clearValidationHash,
    // VALIDATION CODE
    [Types.VALIDATE_CODE_REQUEST]: requestValidationCode,
    [Types.VALIDATE_CODE_SUCCESS]: successValidationCode,
    [Types.VALIDATE_CODE_ERROR]: failureValidationCode,
    // CREATE CUSTOMER
    [Types.CREATE_CUSTOMER_REQUEST]: requestCreateCustomer,
    [Types.CREATE_CUSTOMER_SUCCESS]: successCreateCustomer,
    [Types.CREATE_CUSTOMER_ERROR]: failureCreateCustomer,
    // REPLACE_TOKEN
    [Types.REPLACE_TOKEN]: replaceToken,
    // RESET
    [CommonTypes.WIZARD_RESET]: replaceToken,
    [CommonTypes.UPDATE_ACTIVITY]: updateActivity,
    [CommonTypes.SET_LANGUAGE]: setLanguage,
    // RESEND.

    [Types.RESEND_VALIDATE_PHONE_REQUEST]: requestReSendValidatePhone,
    [Types.RESEND_VALIDATE_PHONE_ERROR]: failureReSendValidatePhone,
    // IdentificationMode
    [Types.TOGGLE_IDENTIFICATION_MODE]: toggleIdentificationMode
});
